module.exports = __webpack_public_path__ + "img/WhatshotOutlined.fec35ef7.svg";